/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ActivityFrom;

(function (ActivityFrom) {
  ActivityFrom["BROKER"] = "broker";
  ActivityFrom["JOVE"] = "jove";
})(ActivityFrom || (ActivityFrom = {}));